import { SxStyles } from '../../types';
import theme from '../../theme';
import { getResponsiveSize } from '../../utils';

export const ClientMediaPlayerSXStyles: SxStyles = {
  ClientMediaPlayerSx: {
    height: '100%',
    '& .player': {
      position: 'absolute',
      justifyContent: 'center',
      alignItems: 'center',
      height: '40%',
      width: '50%',
      left: '25%',
      bottom: '50%',
      transform: 'translateY(50%)',
      pointerEvents: 'none',
    },
    '& .image': {
      position: 'absolute',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      margin: 'auto',
      zIndex: 1,
      height: 'auto',
      '&::before': {
        content: '""',
        paddingTop: '42.25%',
      },
      '& img': {
        position: 'absolute',
        alignSelf: 'center',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        objectFit: 'contain',
      },
    },
  },
};
